module.exports = __webpack_public_path__ + "static/img/douyin.ee61b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin.png
// module id = v5a8
// module chunks = 0